var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.6665V13.3332C2 14.0404 2.28095 14.7187 2.78105 15.2188C3.28115 15.7189 3.95942 15.9998 4.66667 15.9998H12.6667M12.6667 2.6665V29.3332M39.3333 2.6665V13.3332C39.3333 14.0404 39.6143 14.7187 40.1144 15.2188C40.6145 15.7189 41.2928 15.9998 42 15.9998H50M50 2.6665V29.3332M20.6667 5.33317V26.6665C20.6667 27.3737 20.9476 28.052 21.4477 28.5521C21.9478 29.0522 22.6261 29.3332 23.3333 29.3332H28.6667C29.3739 29.3332 30.0522 29.0522 30.5523 28.5521C31.0524 28.052 31.3333 27.3737 31.3333 26.6665V5.33317C31.3333 4.62593 31.0524 3.94765 30.5523 3.44755C30.0522 2.94746 29.3739 2.6665 28.6667 2.6665H23.3333C22.6261 2.6665 21.9478 2.94746 21.4477 3.44755C20.9476 3.94765 20.6667 4.62593 20.6667 5.33317Z",
    stroke: "#2D3232",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.264d9e1b82079c0c203c8de152c6ad4e.svg";
export { ForwardRef as ReactComponent };